export default {
  ITEM: 'item',
  WISH: 'wish',
};

export const ITEM = 'item';
export const TALENT = 'talent';

export const ITEM_NUMBER = 1;
export const TALENT_NUMBER = 2;